<template>
    <v-app>
        <v-navigation-drawer
            :mini-variant="$vuetify.breakpoint.lgAndUp && mini"
            app
            clipped
            v-model="drawer"
        >
            <template v-for="(menuSection, sectionIndex) in menuSections">
                <v-list
                    :key="sectionIndex"
                    class="py-0"
                    v-if="
                menuSection.menuItems.some(y => accessCrud.some(x => x.e && x.e == y.entityType) && accessCrud.find(x => x.e == y.entityType).r )"
                >
                    <v-divider v-if="sectionIndex>0"></v-divider>
                    <!-- <v-subheader class="menu-header">
                    <component
                        :is="menuSection.logo"
                        class="menu-logo"
                    ></component>
                    </v-subheader>-->

                    <!--<v-list-item>
                        <v-list-item-action>
                            <component
                                :is="menuSection.logo"
                                class="menu-logo"
                            ></component>
                        </v-list-item-action>
                        <v-list-item-content>
                            <strong>{{menuSection.name}}</strong>
                        </v-list-item-content>
                    </v-list-item>
                    -->

                    <v-list-item-group>
                        <!--<template v-slot:activator>
                           <v-divider
                                :key="sectionIndex"
                                v-if="sectionIndex>0"
                            ></v-divider>
                            <v-list-item-content class="menu-header">
                                <component
                                    :is="menuSection.logo"
                                    class="menu-logo"
                                ></component>
                            </v-list-item-content>
                        </template>-->
                        <template
                            :disabled="menuItem.to==''"
                            v-for="(menuItem, menuIndex) in menuSection.menuItems"
                        >
                            <v-list-item
                                :disabled="menuItem.to==''"
                                :key="menuIndex"
                                :to="menuItem.to"
                                link
                                v-if="accessCrud.some(x => x.e && x.e == menuItem.entityType) && accessCrud.find(x => x.e == menuItem.entityType).r"
                            >
                                <v-list-item-action>
                                    <v-icon :color="menuSection.color">{{menuItem.icon}}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{menuItem.name}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </template>
        </v-navigation-drawer>
        <v-app-bar
            :hide-on-scroll="$vuetify.breakpoint.mdAndDown"
            app
            clipped-left
            elevation="3"
        >
            <v-app-bar-nav-icon @click.stop="menuButtonToggle"></v-app-bar-nav-icon>
            <!--<Logo
                class="ml-4"
                height="90%"
            />-->
            <v-spacer></v-spacer>
            <!-- <router-view ref="routeHead" name="header"/> -->
            <v-spacer></v-spacer>
            <v-btn
                @click="themeToggle"
                icon
            >
                <v-icon>{{themeIcon}}</v-icon>
            </v-btn>

            <v-btn
                @click="logout"
                icon
            >
                <v-icon>mdi-logout</v-icon>
            </v-btn>
        </v-app-bar>
        <v-main>
            <!--<keep-alive>-->
            <router-view />
            <!--ref="routeBody"-->
            <!--</keep-alive>-->
        </v-main>
    </v-app>
</template>

<script>
import AcciLogo from "../components/logos/AcciLogo.vue";
import ErafLogo from "../components/logos/ErafLogo.vue";
//import SureLogo from "../components/logos/SureLogo.vue";

export default {
    name: "SideNavigationLayout",
    created: async function() {
        this.accessCrud = await this.$store.dispatch(
            "authentication/getAccess"
        );
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
        //console.log(this.accessCrud);
        //console.log(this.userRoles);
        //console.log(!!this.$refs.routeHead);
        //console.log(!!this.$refs.routeBody);
    },
    /* components: {
        ErafLogo
        //
    },*/
    computed: {
        themeIcon() {
            return this.$vuetify.theme.dark
                ? "mdi-brightness-7"
                : "mdi-brightness-4";
        }
    },
    methods: {
        themeToggle() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.setItem(
                "theme",
                this.$vuetify.theme.dark ? "dark" : "light"
            );
        },
        menuButtonToggle() {
            this.mini = this.drawer ? !this.mini : false;
            this.drawer = true;
        },
        logout() {
            this.$store
                .dispatch("authentication/logout")
                .then(() => (window.location = "/"));
        }
    },
    data: () => ({
        accessCrud: [],
        userRoles: [],
        menuSections: [
            new MenuSection("ACCICARE", AcciLogo, "light-green", [
                new MenuItem(
                    "Dashboard",
                    "mdi-view-dashboard-outline",
                    "/Dashboard",
                    "Dashboard"
                ),
                /*
                new MenuItem(
                    "Management Dashboard",
                    "mdi-star-box",
                    "/ManaDashboard",
                    "ManaDashboard"
                ),
                */
                new MenuItem(
                    "Reports",
                    "mdi-file-multiple-outline",
                    "/Reports",
                    "Dashboard"
                ),
                new MenuItem(
                    "Providers",
                    "mdi-stethoscope",
                    "/Providers",
                    "Provider"
                ),
                new MenuItem("Areas", "mdi-circle-outline", "/Areas", "Area"),
                new MenuItem(
                    "Provider Groups",
                    "mdi-google-circles-communities",
                    "/ProviderGroups",
                    "ProviderGroup"
                ),
                new MenuItem("Users", "mdi-account-outline", "/Users", "User"),
                new MenuItem(
                    "Identities",
                    "mdi-card-account-details-outline",
                    "/Identities",
                    "Identity"
                )
            ]),
            new MenuSection("ACCIERAF", ErafLogo, "light-blue", [
                new MenuItem(
                    "Incidents",
                    "mdi-alert-circle-outline",
                    "/Incidents",
                    "Incident"
                ),
                new MenuItem(
                    "Patients",
                    "mdi-alert-circle-outline",
                    "/Patients",
                    "Patient"
                ),
                /*
                new MenuItem(
                    "Billings",
                    "mdi-folder-alert-outline",
                    "/Billings",
                    "Billing"
                ),
                */
                new MenuItem(
                    "Accounts",
                    "mdi-folder-alert-outline",
                    "/Accounts",
                    "Account"
                ),
                new MenuItem(
                    "Claims Pre Subm",
                    "mdi-currency-usd-circle-outline",
                    "/Claims",
                    "ViewClaimPreSubmission"
                ),
                new MenuItem(
                    "Day Batch Subm",
                    "mdi-arrow-right-circle-outline",
                    "/DayBatchesSubmission",
                    "DayBatch"
                ),
                new MenuItem(
                    "Day Batch Post Subm",
                    "mdi-arrow-left-circle-outline",
                    "/DayBatchesPostSubmission",
                    "DayBatch"
                ),
                new MenuItem(
                    "Claims Post Subm",
                    "mdi-check-circle-outline",
                    "/ClaimsPostSubmission",
                    "ViewClaimPostSubmission"
                ),
                //new MenuItem("Finance", "mdi-cash-usd-outline", "", "Claim"),
/*                
                new MenuItem(
                    "Old Incidents",
                    "mdi-alert-rhombus-outline",
                    "/OldIncidents",
                    "OldIncident"
                ),
                new MenuItem(
                    "Medikredit-Claim Files",
                    "mdi-folder",
                    "/MedikreditClaimCsv",
                    "MedikreditClaimCsv"
                ),
                new MenuItem(
                    "Medikredit-Claims",
                    "mdi-file",
                    "/MedikreditClaim",
                    "MedikreditClaim"
                )
*/
                //new MenuItem("Patients", "mdi-human", "/Patients")
            ]),
            /*new MenuSection("ACCISURE", SureLogo, "orange", [
                new MenuItem(
                    "Companies",
                    "mdi-office-building",
                    "/Companies",
                    "CustomerCompany"
                ),
                new MenuItem(
                    "Customers",
                    "mdi-account-cash-outline",
                    "/Customers",
                    "Customer"
                ),
                new MenuItem(
                    "Subscriptions",
                    "mdi-card-account-details-star-outline",
                    "/Subscriptions",
                    "Subscription"
                ),
                new MenuItem(
                    "Representatives",
                    "mdi-account-hard-hat",
                    "/Representatives",
                    "Representative"
                ),
                new MenuItem(
                    "Representative Products",
                    "mdi-group",
                    "/RepresentativeProducts",
                    "RepresentativeProduct"
                ),
                new MenuItem(
                    "Subscribe Form Submission",
                    "mdi-account-details-outline",
                    "/SubscribeFormSubmissions",
                    "SubscribeFormSubmission"
                ),

                new MenuItem(
                    "Unmatched Sms Replies",
                    "mdi-star",
                    "/UnmatchedSmsReplyMessages",
                    "Customer"
                ),
                new MenuItem(
                    "Declined Sms Replies",
                    "mdi-star",
                    "/DeclinedSmsReplyMessages",
                    "Customer"
                ),

                new MenuItem(
                    "Brokers",
                    "mdi-circle",
                    "/Brokers",
                    "Broker"
                ),
                new MenuItem(
                    "Broker Firms",
                    "mdi-circle",
                    "/BrokerFirms",
                    "BrokerFirm"
                ),
            ])*/
        ],
        drawer: null,
        mini: true
        //
    })
};
class MenuSection {
    constructor(name, logo, color, menuItems) {
        this.name = name;
        this.logo = logo;
        this.color = color;
        this.menuItems = menuItems;
    }
}

class MenuItem {
    constructor(name, icon, to, entityType) {
        this.name = name;
        this.icon = icon;
        this.to = to;
        this.entityType = entityType;
    }
}
</script>

<style lang="stylus">
.menu-logo {
    height: 24px;
    width: 24px;
}
</style>